import { spacing } from '@/features/shared/theme/tokens'
import { type Banner } from '@/features/shop/services/Banners/types'
import { Body } from '@shipt/design-system-typography'
import { useEffect } from 'react'
import styled from 'styled-components'
import { trackElementViewed } from '@/features/shared/analytics/element'

type Props = {
  data: Banner
}

export const HeaderBanner = ({ data }: Props) => {
  const { text } = data
  useEffect(() => {
    // given the nature of this banner, we should assume it's always visible when its rendered
    // therefore, have this track call on mount is appropriate, and we don't need to leverage
    // intersection observer or ScrollIntoView component
    trackElementViewed({
      type: 'banner',
      message_goal: 'header_banner',
      content: text,
    })
  }, [text])
  return (
    <BannerWrapper>
      <Body surface="inverse" align="center" size="md" strong>
        {text}
      </Body>
    </BannerWrapper>
  )
}

const BannerWrapper = styled.div`
  padding: ${spacing('sm', 0)};
  background-color: ${({ theme }) => theme.color.background.base.brand.primary};
`
